import { render } from "./hrm-punch-widget.vue?vue&type=template&id=368a4606&scoped=true"
import script from "./hrm-punch-widget.vue?vue&type=script&lang=js"
export * from "./hrm-punch-widget.vue?vue&type=script&lang=js"

import "./hrm-punch-widget.vue?vue&type=style&index=0&id=368a4606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368a4606"]])

export default __exports__